import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Table } from "reactstrap";
import { NavLink } from "react-router-dom";
import SvgImage from "../../Icons/Icons";
import "./index.css";
import moment from "moment";
import { useParams } from "react-router-dom";

import { DatePickerField, DateRangePickerField } from "../../core/inputs/input";
import ShowExcelVendor from "./ShowExcelVendor";
import SelectVendorModal from "./Modal/SelectVendorModal";
import {
  cleanVendorTransaction,
  generateStatementForVendorAction,
  transferTorVendorAction,
  vendorGetSignedUrlAction,
  vendorTransactionAction,
  vendorUploadBillAction,
} from "../../../services/Store/Actions/beneficiaryAction";
import PaymentModal from "./Modal/PaymentModal";
import PinModal from "./Modal/PinModal";
import { wait } from "@testing-library/user-event/dist/utils";
import NoTransaction from "../../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/TabularData/NoTransaction.js";
import { ClipLoader } from "react-spinners";
import Toast from "../../subComponents/toast";
import { downloadBulkVendor, uploadBulkVendor } from "../../../services/Store/Actions/customerAction";
import { toast, ToastContainer } from "react-toastify";
import PinInput from "react-pin-input";
import { getSignedUrlApiAction } from "../../../services/Store/Actions/appActions";
import VendorSuccess from "../../Modals/VendorSuccess";
function VendorTransactions(props) {
  const [offset, setOffset] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [selectVendorModal, setSelectVendorModal] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [offset2, setOffset2] = useState(0);
  const [enterPin, setEnterPin] = useState(false);
  const [paymentData, setPaymentData] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [successText, setSuccessText] = useState("");
  const [vendorData, setVendorData] = useState(false);
  const [paymetModal, setPaymentModal] = useState(false);
  const [pinLoader, setPinLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [failedModal, setFailedModal] = useState(false);
  const [failedMsg, setFailedMsg] = useState();
  const [loader, setLoader] = useState(false);
  const [bulkTransferId, setBulkTransferId] = useState(null);
  const [modal, setModal] = useState(false);
  const [pin,setPin] = useState('');
  const [selectBulk,setSelectBulk] = useState(false);
  
  const { isLogipeVendor, search, setSearch } = props;
  const toggleModal = () => {
    setModal(!modal);
  };

  const showModalVendorSheet = () => {
    setModal(true);
  };
  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const dispatch = useDispatch();
  const { vendorTransactionList, vendorTransaction } = useSelector(
    (state) => state?.beneficiary
  );
  const trxnCount = vendorTransaction?.count;
  console.log("vendorTransactionList", vendorTransactionList);
  const handlePageClick = (event) => {
    console.log("Clickess");
    const newOffset = event.selected * 7;
    setOffset(newOffset);
  };
  const datepickerRefStart = useRef();
  const handleClickDatepickerIcon1 = () => {
    const datepickerElement = datepickerRefStart.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const datepickerRefEnd = useRef();
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };

  const { authUser } = useSelector((state) => state?.loginReducer);
  const { managerControlList } = useSelector((state) => state?.userManagement);
  const [isTrips,setIsTrips] = useState(0); 
  const [isCustomers,setIsCustomers] = useState(0); 
  const [isVendor,setIsVendor] = useState(0); 
  useEffect(()=>{
    setIsTrips(authUser?.company?.isTrips && authUser?.user?.type==2?3: authUser?.company?.isTrips && managerControlList?.tripAccess?managerControlList?.tripAccess:0)
    setIsCustomers(authUser?.company?.isCustomers && authUser?.user?.type==2?3: authUser?.company?.isCustomers && managerControlList?.customerAccess?managerControlList?.customerAccess:0)
    setIsVendor(authUser?.company?.isVendor && authUser?.user?.type==2?3: authUser?.company?.isVendor && managerControlList?.vendorAccess?managerControlList?.vendorAccess:0)
  },[authUser,managerControlList])


  useEffect(() => {
    dispatch(
      vendorTransactionAction({
        limit: 7,
        offset: offset,
        from: "",
        to: "",
        isLogipeVendor: isLogipeVendor,
      })
    );
    return () => {
      dispatch(cleanVendorTransaction());
      setStartDate("");
      setEndDate("");
      setVendorData({});
      setPaymentData({});
    };
  }, []);
  useEffect(() => {
    dispatch(cleanVendorTransaction());
    setStartDate("");
    setEndDate("");
    setVendorData({});
    setPaymentData({});
    dispatch(
      vendorTransactionAction({
        limit: 7,
        offset: offset,
        from: "",
        to: "",
        isLogipeVendor: isLogipeVendor,
      })
    );
  }, [isLogipeVendor]);
  useEffect(() => {
    dispatch(cleanVendorTransaction());
    dispatch(
      vendorTransactionAction({
        limit: 7,
        offset: offset,
        from: startDate || "",
        to: endDate || "",
        isLogipeVendor: isLogipeVendor,
      })
    );
  }, [startDate, endDate, isLogipeVendor]);
  function findSearch() {}
  const [fileSave, setFileSave] = useState(null);
  const [dispatchTransfer, setDispatchTransfer] = useState(false);
  const [bulkTransfer, setBulkTransfer] = useState(false);
  const [bulkTransferStatus, setBulkTransferStatus] = useState(false);
  
  const customId1 = "vendor-download-page";
  const downloadVendorrPayout = () => {
    dispatch(
      downloadBulkVendor("", (res) => {
        console.log("downloadVendorrPayout", res?.data);
        if (res?.status == 200) {
          toast.success("Template was downloaded successfully.", {toastId:"VendorDownload"})
          const blob = new Blob([res?.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `file.xls`; //name to changed here
          link.click();
          
        }
      })
    );
  };
  const checkStatus = () => {
    const key = `${authUser?.company?.companyId}-${bulkTransferId}.csv`
    console.log("checkStatuscheckStatus",key);
    dispatch(getSignedUrlApiAction({ key }, async(res)=> {
      if(res.status == 200){
        await fetch(res?.data?.data).then(response => {
          console.log("checkStatuscheckStatus",response.data);
        }).catch((err) => { toast.error("transaction in progress! check after some time!");})
        // window.open(res?.data?.data)
      }
      else toast.error("Transaction is in process")
    }))
  }
  const bulkTransferCall = () => {
    console.log("loader && !dispatchTransfer",loader , dispatchTransfer);
    setLoader(true);
      dispatch(
        uploadBulkVendor({ file: fileSave, bulkTransferId,pin:pin }, (res) => {
          console.log("uploadBulkVendoruploadBulkVendor",res);
          setLoader(false);
          if (res.status == 200) {
            const blob = new Blob([res?.data]);
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `responseFile.xls`; //name to changed here
            link.click();
            toast.success("Transfer Vendor Bulk updated successfully.", {toastId:"VendorUpload"})
            setBulkTransfer(false);
          } else {
            if(res.status == 502){
              setBulkTransferStatus(true)
            }
            toast.error(res.data?.message || "some error occured");
          }
        })
      );
  }

  const handlePrev = () => {
    if (offset > 0) {
      dispatch(cleanVendorTransaction());
      setOffset(offset - 7);
      dispatch(
        vendorTransactionAction({
          limit: 7,
          offset: offset - 7,
          from: startDate || "",
          to: endDate || "",
          isLogipeVendor: isLogipeVendor,
        })
      );
    }
  };
  const handleNext = () => {
    console.log("offset,trxnCount", offset, trxnCount);
    if (offset + 7 < trxnCount) {
      dispatch(cleanVendorTransaction());
      setOffset(offset + 7);
      dispatch(
        vendorTransactionAction({
          limit: 7,
          offset: offset + 7,
          from: startDate || "",
          to: endDate || "",
          isLogipeVendor: isLogipeVendor,
        })
      );
    }
  };
  return (

    <div
    className="container topMargin"
    style={{
      height: "100%",
      marginLeft: "270px",
      maxWidth: windowWidth - 360,
    }}
  >
    <div className="vendorBg containerShadow" style={{ paddingTop: "1px" }}>
      {selectVendorModal && (
        <SelectVendorModal
          open={selectVendorModal}
          onHide={() => {
            setSelectVendorModal(false);
          }}
          toggleModal={() => {
            setSelectVendorModal(!selectVendorModal);
          }}
          handleClose={() => {
            setSelectVendorModal(false);
          }}
          onClickItem={(data) => {
            setVendorData({});
            setVendorData(data);
            setPaymentModal(true);
            setSelectVendorModal(false);
          }}
          search={search}
          setSearch={setSearch}
        />
      )}
      {paymetModal && (
        <PaymentModal
          open={paymetModal}
          onHide={() => {
            setPaymentModal(false);
            setVendorData({});
          }}
          toggleModal={() => {
            setVendorData({});
            setPaymentModal(!paymetModal);
          }}
          handleClose={() => {
            setVendorData({});
            setPaymentModal(false);
          }}
          onSubmit={(data) => {
            setPaymentModal(false);
            setEnterPin(true);
            setPaymentData(data);
          }}
          vendorData={vendorData}
        />
      )}
      {enterPin && (
        <PinModal
          open={enterPin}
          onHide={() => {
            setVendorData({});
            setEnterPin(false);
          }}
          toggleModal={() => {
            setVendorData({});
            setEnterPin(!enterPin);
          }}
          handleClose={() => {
            setVendorData({});
            setEnterPin(false);
          }}
          pinLoader={pinLoader}
          onSubmit={(data) => {
            setPinLoader(true);
            dispatch(
              transferTorVendorAction(
                {
                  mode: vendorData?.vpaId == "" ? "BANK_TRANSFER" : "UPI",
                  pin: data?.pin?.toString(),
                  amount: paymentData?.amount?.toString(),
                  remark: paymentData?.remarks,
                  vendorId: vendorData?.id?.toString(),
                },
                (res) => {
                  setPinLoader(false);
                  console.log(res?.data);
                  setVendorData({});
                  if (res?.status == 200) {
                    setSuccessModal(true);
                    setSuccessText(
                      `₹${paymentData?.amount} has been payed to your vendor from Master Account.`
                    );
                    setEnterPin(false);
                    wait(1000).then(() => {
                      dispatch(cleanVendorTransaction());
                      dispatch(
                        vendorTransactionAction({
                          limit: 7,
                          offset: offset,
                          from: "",
                          to: "",
                          isLogipeVendor: isLogipeVendor,
                        })
                      );
                    });
                  } else {
                    setFailedMsg(res?.data?.message);
                    setSuccessModal(false);
                    setEnterPin(false);
                    setFailedModal(true);
                  }
                }
              )
            );
          }}
          data={paymentData}
          isLogipeVendor={isLogipeVendor}
        />
      )}
      {successModal && (
        <VendorSuccess
          open={successModal}
          onHide={() => {
            setSuccessModal(false);
            setPaymentData({});
            setSuccessText("");
          }}
          toggleModal={() => {
            setSuccessModal(!successModal);
            setPaymentData({});
            setSuccessText("");
          }}
          handleClose={() => {
            setSuccessModal(false);
            setPaymentData({});
            setSuccessText("");
          }}
          text={successText}
        />
      )}
      {failedModal && (
        <Toast
          success={0}
          message={failedMsg || "Failed to Transfer Amount"}
          toggleModal={() => {
            setFailedModal(false);
            setFailedMsg();
          }}
          isOpen={failedModal}
          name="vendor"
          handleClose={() => {
            setFailedModal(false);
            setFailedMsg();
          }}
        />
      )}
      <div className="row">
        <div className="col-3 transfer-box-2">
          <div className="Transfer-To-Logipe-Vendor-Bg pt-2">
            <SvgImage name={"TransferToLogipeVendor"} />
          </div>
          <div>
            <button
              className="greenButton Transfer-Btn"
              onClick={() => {
                if(["2","3",2,3].includes(isVendor)) setSelectVendorModal(true);
              }}
              style={{
                marginTop: "12px",
                paddingRight: "20px",
                paddingLeft: "20px",
              }}
            >
              <text style={{}}>Transfer</text>
            </button>
          </div>
          
        </div>
        <div className="col-3 transfer-box-2">
          <div className="Transfer-To-Logipe-Vendor-Bg pt-2">
            <SvgImage name={"TransferToLogipeVendor"} />
          </div>
          <div>
            <button
              className="greenButton Transfer-Btn"
              onClick={() => {
                if(["2","3",2,3].includes(isVendor)) setSelectBulk(true);
              }}
              style={{
                marginTop: "12px",
                paddingRight: "20px",
                paddingLeft: "20px",
              }}
            >
              <text style={{}}> Bulk Transfer</text>
            </button>
          </div>
          
        </div>
        <div className="col-6">
        {selectBulk ? <div className="row">
          <div className="col-6 uploadBox"  >
        <div style={{ display: "flex", flexDirection: "row", marginTop:"10px" }}>
              <div
                className="col-lg-6"
                style={{ paddingTop: "10px", paddingBottom: "40px" }}
                onClick={downloadVendorrPayout}
              >
                <div className="svgContainerUp" style={{ margin: "0 23px" }}>
                  <SvgImage name="Download" />
                </div>
                <div className="Bold300" style={{ textAlign: "center" }}>
                  Download Template For Bulk Transfer
                </div>
              </div>
              <div className="col-lg-6" style={{ paddingTop: "10px", paddingBottom: "40px"  }}>
                <label for="file-upload2" class="custom-file-upload3">
                  <input
                    id="file-upload2"
                    type="file"
                    onChange={async (e) => {
                      const img = e?.target.files[0];
                      setFileSave(img);
                      console.log("image...", e?.target.files[0]);
                      setBulkTransfer(true);
                    }}
                  />
                  <div
                    className="svgContainerUp"
                    style={{
                      margin: "0px 23px",
                      backgroundColor: bulkTransfer  ? "antiquewhite" : null,
                    }}
                  >
                    <SvgImage name="Upload" />
                  </div>
                  <div className="Bold300" style={{ textAlign: "center" }}>
                    Upload for bulk Transfers
                  </div>
                </label>
              </div>
            </div>
        </div>
        <div className="col-6 ">
        {(bulkTransfer || bulkTransferStatus )&& (
         <div className="uploadBox">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: ""
          }}
        >
          <div style={{ margin: ".5rem" }}>
            <a disabled={loader} style={{ margin: ".5rem" }} href={fileSave}>
              {fileSave?.name ? fileSave?.name.slice(0,15)+"..." : "test.xlxs"}
            </a>
            <a
              onClick={() => {
                console.log("ckisnkeddd");
                showModalVendorSheet()
              }}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "blue",
                marginLeft:"20px"
              }}
            >
              View
            </a>
          </div>
          <div style={{}}>
            <input
              type="text"
              className=""
              name="bulkTransferId"
              placeholder="Enter Unique TransferId"
              disabled={loader}
              onChange={(e) => {
                console.log(e.target.value);
                setBulkTransferId(e.target.value);
              }}
            />
          </div>
          <ShowExcelVendor
        toggle={toggleModal}
        modal={modal}
        setModal={setModal}
        fileSave={fileSave}
      />
          <div>
          <PinInput
                    length={4}
                    initialValue=""
                    secret
                    onChange={(val)=>{
                      // handleChange("pin")
                    console.log("val...",val, bulkTransferId, dispatchTransfer, loader)
                    setPin(val)
                    if(val.length == 4 && bulkTransferId){
                      setDispatchTransfer(true)
                    }else{
                      setDispatchTransfer(false)
                    }
                    }}
                    type="numeric"
                    value={pin}
                    // onBlur={handleBlur("pin")}
                    // touched={touched.pin}
                    // errors={errors.pin}
                    inputMode="number"
                    style={{
                      marginTop: "10px",
                    }}
                    inputStyle={{
                      border: "1px solid #A7A7A7",
                      borderRadius: "8px",
                      marginRight: "5px",
                    }}
                    autoSelect={true}
                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                  />
            {bulkTransferStatus ? <Button
              className="greenButton"
              style={{ margin: ".5rem", marginLeft: "70px",backgroundColor: (pin.length==4 && bulkTransferId) ? "#485b7c":"grey" }}
              onClick={checkStatus}
              disabled={ loader}
            >
              {"Check Status"}
            </Button> :
            <Button
            className="greenButton"
            style={{ margin: ".5rem", marginLeft: "70px",backgroundColor: (pin.length==4 && bulkTransferId) ? "#485b7c":"grey" }}
            onClick={bulkTransferCall}
            disabled={ loader}
          >
            {" "}
            {loader ? "Please Wait":"Transfer"}
          </Button> }
          </div>
        </div>
       
          </div> 
           )}
        </div>
        </div> : <></>}
        </div>
      </div>

      <div className="col-12">
        <div className="row align-items-center;">
          <div className="col-6">
            <p className="vendor-List-title">Transaction History</p>
          </div>
          <div className="col-6 pt-2">
            {trxnCount != 0 && (
              <div style={{display:"flex", flexDirection:"row"}}>
               <div className="row selectDate-input-Bg">
              <div
                className="custNamepadd3 row"
                style={{ width: "225px" }}
              >
              <div className="col-9">
                <DateRangePickerField
                  classname="inputBoxCust1"
                  name="date"
                  header="date"
                  value={{startDate :startDate, endDate: endDate}}
                  onChange={(v) => {
                    setStartDate(v[0]);
                    setEndDate(v[1]);
                  }}
                  onFocus={() => {
                    handleClickDatepickerIcon1();
                  }}
                  maxDate={endDate === "" ? new Date() : endDate}
                  ref1={datepickerRefStart}
                />
                </div>
                <div className="col-3" style={{  marginRight: "-30px"}}>
                  <label
                    className="date-input"
                    for="startDate"
                    style={{
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleClickDatepickerIcon1();
                    }}
                  >
                    {!endDate ?<SvgImage
                    name="CalenderLogo"
                    width="32"
                    height="32"
                    // classname="date-logo"
                  /> : <></>}
                  </label>
                </div>
                    </div>
            </div>
                {downloadLoader ? (
                  <div className=" downloadText">
                    <ClipLoader
                      color={"#485B7C"}
                      loading={true}
                      size={20}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />{" "}
                    downloading ...
                  </div>
                ) : (
                  <div
                    className=" downloadText"
                    onClick={() => {
                      setDownloadLoader(true);
                      dispatch(
                        generateStatementForVendorAction(
                          {
                            from: startDate || "",
                            to: endDate || "",
                            isLogipeVendor: isLogipeVendor,
                          },
                          (res) => {
                            setDownloadLoader(false);
                            if (res?.status) {
                              window.open(res?.data?.data?.url);
                            }
                          }
                        )
                      );
                    }}
                  >
                    <div style={{ marginRight: "8px" }}>
                      <SvgImage name="downloadImgV2" />
                    </div>
                    Download Statement
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {trxnCount == undefined ? (
        <NoTransaction />
      ) : trxnCount == 0 ? (
        <NoTransaction />
      ) : (
        <div className="table-for-Vendor">
          <Table className="vehicleAssignedHistory">
            <thead className="th" style={{ zIndex: 99 }}>
              <tr className="table-header-vendor-details">
                <th className="vendor-transaction-header col-2">Date & Time</th>
                <th className="vendor-transaction-header col-2">
                  Beneficiary Name
                </th>
                <th className="vendor-transaction-header col-2">UTR No.</th>
                
                <th className="vendor-transaction-header col-1.5">
                  Payment Mode
                </th>
                <th className="vendor-transaction-header">Amount</th>
                <th className="vendor-transaction-header">Status</th>
                
                
                <th className="col-2 vendor-transaction-header">
                  Upload / View Invoice
                </th>
              </tr>
            </thead>
            {/* <div className="tbodyVehicle-div"> */}
            <tbody className="tbodyVendor" style={{ textDecoration: "none" }}>
              {vendorTransactionList?.map((items, i) => {
                console.log("-----------", i);
                return (
                  <>
                    {i < 7 && i >= 0 ? (
                      <tr className="table-row-vendor-details table-row-transaction-history ">
                        <td
                          className="col-2"
                          style={{
                            verticalAlign: "middle",
                            borderRightWidth: 1,
                          }}
                        >
                          {moment(items?.createdAt).format(
                            "DD/MM/YYYY, hh:mm a"
                          )}
                        </td>
                        <td
                          className="col-2"
                          style={{
                            verticalAlign: "middle",
                            borderRightWidth: 1,
                          }}
                        >
                          {items?.beneficiaryName}
                        </td>
                        <td
                          className="col-2"
                          style={{
                            verticalAlign: "middle",
                            borderRightWidth: 1,
                            wordBreak: "break-all"
                          }}
                        >
                          {items?.bank_ref_no}
                        </td>
                        
                        
                        <td
                          className="col-1.5"
                          style={{
                            verticalAlign: "middle",
                            borderRightWidth: 1,
                            wordBreak:"break-all"
                          }}
                        >
                          {items?.payment_mode}
                        </td>
                        <td
                          style={{
                            verticalAlign: "middle",
                            borderRightWidth: 1,
                          }}
                        >
                          ₹{items?.amount}
                        </td>
                        <td
                          style={{
                            verticalAlign: "middle",
                            borderRightWidth: 1,
                            color:
                              items?.status == "Success"
                                ? "#09BD7B"
                                : "#E63946",
                          }}
                        >
                          {items?.status}
                        </td>
                        
                        <td
                          className="col-2"
                          style={{
                            verticalAlign: "middle",
                            borderRightWidth: 1,
                          }}
                        >
                          <div className="row">
                            <div className="col-1 upload-Icon" type="button">
                              <SvgImage name="uploadIconV2" />
                              <div style={{ position: "absolute" }}>
                                <input
                                  type="file"
                                  // accept="image/*"
                                  className="add-attachment-btn-4"
                                  onChange={async (e) => {
                                    const img = e?.target.files[0];
                                    // setFileUp( e?.target.files[0]);
                                    console.log("image", img?.name);
                                    if (img !== null) {
                                      dispatch(
                                        vendorUploadBillAction(
                                          {
                                            transaction_id:
                                              items?.transaction_id,
                                            img: img,
                                          },
                                          (res) => {
                                            if (res?.type == "success") {
                                              setSuccessModal(true);
                                              setSuccessText(
                                                `Image Uploaded Successfully`
                                              );
                                              wait(1400).then(() => {
                                                dispatch(
                                                  cleanVendorTransaction()
                                                );
                                                dispatch(
                                                  vendorTransactionAction({
                                                    limit: 7,
                                                    offset: offset,
                                                    from: "",
                                                    to: "",
                                                    isLogipeVendor:
                                                      isLogipeVendor,
                                                  })
                                                );
                                              });
                                            } else {
                                              setFailedMsg(res?.data?.message);
                                              setSuccessModal(false);
                                              setEnterPin(false);
                                              setFailedModal(true);
                                            }
                                          }
                                        )
                                      );
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            {items?.doc_url != null && (
                              <div
                                className="col-1"
                                onClick={() => {
                                  dispatch(
                                    vendorGetSignedUrlAction(
                                      { key: items?.doc_url },
                                      (res) => {
                                        console.log(
                                          "vendorGetSignedUrlAction",
                                          res
                                        );
                                        if (res?.status == 200) {
                                          window.open(
                                            res?.data?.data,
                                            "_blank",
                                            "noopener,noreferrer"
                                          );
                                        }
                                      }
                                    )
                                  );
                                }}
                              >
                                <SvgImage name="ViewInvoice" />
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                  </>
                );
              })}
            </tbody>
            {/* </div> */}
          </Table>
          {/* {
          olderHistoryStatus?
          <div className="olderTransactions-div" onClick={handleOlderTransactions}>
          Older History
          </div>:
        <></>
        } */}
          {trxnCount > 0 && (
            <div className="row margin0 padding16">
              <div
                className="col-4"
                style={{
                  textAlign: "right",
                  paddingTop: "0.1rem",
                  cursor: offset > 0 ? "pointer" : "no-drop",
                  opacity: offset > 0 ? "1" : "0.5",
                }}
                onClick={handlePrev}
              >
                <SvgImage name="PrevArrow" />
              </div>
              <div
                className="col-1 greenFont semiBold heading4 padding0L"
                style={{
                  textAlign: "right",
                  paddingTop: "0.3rem",
                  cursor: offset > 0 ? "pointer" : "no-drop",
                  opacity: offset > 0 ? "1" : "0.5",
                }}
                onClick={handlePrev}
              >
                Previous
              </div>
              <div className="col-2 row margin0 justify-content-center">
                <div
                  className="greenBoxCount Medium heading4 col-4"
                  style={{
                    width: "2rem",
                    height: "2rem",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {offset / 7 + 1}
                </div>
                <div
                  className=" col-4 padding0R"
                  style={{ paddingTop: "0.3rem", textAlign: "right" }}
                >
                  <div style={{display: "flex", flexDirection: "row"}}>
                      <div>of{" "}</div>
                      <div style={{marginLeft: "10px"}}>{trxnCount % 5 == 0
                      ? Math.floor(trxnCount / 5)
                      : Math.floor(trxnCount / 5 + 1)}</div>
                    </div>
                </div>
              </div>
              <div
                className="col-1 greenFont semiBold heading4 padding0R"
                style={{
                  textAlign: "left",
                  paddingTop: "0.3rem",
                  cursor: trxnCount - offset > 7 ? "pointer" : "no-drop",
                  opacity: trxnCount - offset > 7 ? "1" : "0.5",
                }}
                onClick={handleNext}
              >
                Next
              </div>
              <div
                className="col-4 padding0L"
                style={{
                  textAlign: "left",
                  marginLeft: "-1rem",
                  paddingTop: "0.1rem",
                  cursor: trxnCount - offset > 7 ? "pointer" : "no-drop",
                  opacity: trxnCount - offset > 7 ? "1" : "0.5",
                }}
                onClick={handleNext}
              >
                <SvgImage name="NextArrow" />
              </div>
            </div>
          )}
        </div>
      )}
      <ToastContainer
    theme="dark"
    position="top-right"
    closeOnClick
    pauseOnHover
    autoClose={4000}
  />
    </div>
    </div>
  );
}
export default VendorTransactions;
